export default function navigationWidth(isCollapsed: boolean): number {
    return isCollapsed ? 55 : 150;
}
